import { HttpClient } from '@connect-x-app/hybrid-data-access';
import { SystemMessageConfiguration } from '@connect-x-app/shared-domain-models';
import { API_FACTORY } from '@connect-x-app/shared-utils';

export const getSystemMessages = (): Promise<Required<SystemMessageConfiguration>> =>
  HttpClient.get(API_FACTORY.v1('admin/messages-configuration'));

export const updateSystemMessages = (systemMessageConfiguration: SystemMessageConfiguration) =>
  HttpClient.put(API_FACTORY.v1('admin/messages-configuration'), systemMessageConfiguration);
